import { useContext, useEffect } from "react"
import { authContext } from '../../context/auth-context'
import { Navigate, Outlet, useLocation, useNavigate, useOutletContext, } from 'react-router-dom'
import useGetData from '../../hooks/useGetData'
import departmentsApi from '../../services/deparmentsApi'
import classes from '../../styles/Tasks.module.css'
import Button from '../../components/UI/Button'
import RenderIf from '../../components/UI/RenderIf'
import FormSpinner from '../../components/UI/FormSpinner'
import DepartmentsTable from '../Table/DepartmentsTable'

const ListDepartments = (props) => {
    const navigate = useNavigate()
    const { departments, departmentsLoading } = useOutletContext()

    return (
        <>
                <div className={`${classes.header_container} mb-4`}>
                    <h4 id='formTitle'>Departments</h4>
                    <Button onClickHandler={() => navigate('/departments/create-department')} text='Create Department' />
                </div>
                <RenderIf isTrue={departmentsLoading}>
                    <div className='centerSpinner'>
                        <FormSpinner color='#0d6efd' />
                    </div>
                </RenderIf>
                <RenderIf isTrue={!departmentsLoading}>
                    <DepartmentsTable departments={departments} />
                </RenderIf>
        </>
    )
}

export default ListDepartments